import { faInfoCircle, faSpinner, faExclamationCircle } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter';
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore';
import { useHistory, useLocation } from 'react-router-dom';
import React, { Fragment, useEffect, useRef, useState, useContext } from 'react';
import BellSound from '../../../assets/sounds/shipbell.wav';
import { HeaderWrapper } from '../InterviewDatesWrapper.styles';
import { Alert, Button, Input } from 'reactstrap';
import { DepartmentContext } from '../../../DepartmentWrapper';
// import io from 'socket.io-client';
import styled from 'styled-components';
import Swal from 'sweetalert2';
import { toast } from 'react-toastify';
import {
  getPercentageTime,
  renderCandidateNotFound,
  shouldJoinMeetingButtonBeVisisble,
  renderMeetingDetailsCard,
  checkForScheduleDisabledButton,
  getArrayIndexesWithDifferencesViaTimeSlot,
  isRezrateEmbeddedMeetingUrl as shouldResolveRezrateEmbeddedMeeting,
  openUrlInNewTabOrDetectBlock,
  preOpenNamedMeetingWindow,
  urlWithHttpProtocol,
  isNotificationsSupported,
  checkIfMeetingIsBeforeCurrentJoinedMeeting,
} from '../../../Common.functions';
import { createTimeTracker } from '../../../Common.jsx';
import { fetchDataAgnostic } from '../../../Services/dataApi';
import {
  buildEmbeddedMeetingVideoUrl,
  buildRezrateVideoShellUrl,
  createOrReuseRezrateVideoSession,
  removeRezrateVideoSession,
  REZRATE_VIDEO_WINDOW_TARGET,
} from '../../../Services/rezrateVideoShell';
import { cssSizes } from '../../Common.style';
import Error from '../../Statuses/Error';
import Loading from '../../Statuses/Loading';
import { demoUserObject, getNextFriday, mockScheduledTimes } from '../demo';
import { CustomCard, CustomCardHeader, CustomCol } from '../InterviewDatesWrapper.styles';
import { CustomTable } from './InterviewDateConfirm.styles';
import { useAuth0 } from '../../../auth0/reactAuth0Spa';
import CandidateHeader from '../../../Header/header.container';
const replaceWithNumber = '|###|';
const pendingStatus = `You're pending`;

dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(isSameOrAfter);
dayjs.extend(isSameOrBefore);

const constructApiUrl = (url) => {
  const { REACT_APP_BUILD_TYPE } = process.env;

  if (REACT_APP_BUILD_TYPE && REACT_APP_BUILD_TYPE === 'liveproduction') {
    return 'https://prodapi.rezrate.com/' + url;
  }

  if (REACT_APP_BUILD_TYPE && REACT_APP_BUILD_TYPE === 'livedevelopment') {
    return 'https://devapi.rezrate.com/' + url;
  }

  return `https://devapi.rezrate.com/` + url;
};
const TDPadding = styled.td`
  width: 25%;
  ${cssSizes.phoneLandscape`
    width: 0;
  `}
  ${cssSizes.tabletLandscape`
    width: 10vw;
  `}
`;

const CandidateWorkspace = styled.div`
  display: flex;
  gap: 20px;
  align-items: stretch;

  @media (max-width: 1100px) {
    flex-direction: column;
  }
`;

const CandidateSchedulePane = styled.div`
  flex: ${({ $hasVideo }) => ($hasVideo ? '0 1 54%' : '1 1 100%')};
  min-width: 0;
`;

let highlightClearTimeout = null;
const alternatingRowColors = ['#ffffff', '#f1f1f1'];

const InterviewSchedule = (props) => {
  React.useEffect(() => {
    var timerID = setInterval(() => tick(), 500);
    return function cleanup() {
      clearInterval(timerID);
    };
  });

  const isDemo = () => {
    const { match = {} } = props;
    const { params = {} } = match;
    const { id = 'DEMO' } = params;

    if (id.toUpperCase() === 'DEMO') {
      return true;
    }
    return false;
  };

  const clientID = props.match.params.id;
  const [demo, setDemo] = useState(isDemo());
  let elementsRef;
  const [currentTime, setCurrentTime] = useState(Date.now());
  const [currentTimeAsMoment, setCurrentTimeAsMoment] = useState(dayjs(Date.now()));
  const [topOpacity, setTopOpacity] = useState(0);
  const [headerOpacity, setHeaderOpacity] = useState(0);
  const [heights, setHeights] = useState(null);
  const [isLocalTime, setIsLocalTime] = useState(true);
  const [passWord, setPassword] = useState('');
  const [loading, setLoading] = useState(true);
  const [scheduledTimes, setScheduledTimes] = useState([]);
  const [firstBlockEarlyJoinInMinutes, setFirstBlockEarlyJoinInMinutes] = useState(0);
  const [interviewIsToday, setInterviewIsToday] = useState(false);
  const [error, setError] = useState(false);
  const [mainRoomDescription, setMainRoomDescription] = useState(null);

  const [displayJoinMeetingButtonInfo, setDisplayJoinMeetingButtonInfo] = useState(false);
  const [copied, setCopied] = useState(false);
  const [meetingId, setMeetingId] = useState(null);
  const [statusPending, setStatusPending] = useState(true);

  const [interviewDate, setInterviewDate] = useState(null);
  const [noData, setNoData] = useState(false);
  const [showMeetingCard, setShowMeetingCard] = useState(false);
  const [tableRowOpacity, setTableRowOpacity] = useState(0);
  const [virtualMeetingMode, setVirtualMeetingMode] = useState('');
  const [demoTimeDifference, setDemoTimeDifference] = useState(null);
  const [zoomPassword, setZoomPassword] = useState('');

  const [preventJoinMeetingClick, setPreventJoinMeetingClick] = useState(false);
  const [hasRoomNumber, setHasRoomNumber] = useState(false);
  const [zoomInfo, setZoomInfo] = useState([]);

  const [meetingLink, setMeetingLink] = useState('');
  const [nonZoomInfo, setNonZoomInfo] = useState('');
  const [breakRoom, setBreakRoom] = useState({ url: '', buttonText: '', details: '' });

  const [passingPeriod, setPassingPeriod] = useState(null);
  const [scheduleWithPassingPeriods, setScheduleWithPassingPeriods] = useState({}); // {pk_Timeslot: endTimeWithPassingPeriod}, used for alerts that play befoer end of event + end of passing period
  const [startMonth, setStartMonth] = useState();
  const [endMonth, setEndMonth] = useState();
  const [firstEvent, setFirstEvent] = useState(); // First non-filler event/meeting
  const [validCandidate, setValidCandidate] = useState(true);
  const [indexesWithDifferences, setIndexesWithDifferences] = useState([]);
  const [alerts, setAlerts] = useState([]);
  const [alertedEvents, setAlertedEvents] = useState([]);
  const [pk_Candidate, set_pk_Candidate] = useState();
  const [rawData, setRawData] = useState();
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [isLoadingSchedule, setIsLoadingSchedule] = useState(false);
  const [hasScheduleError, setHasScheduleError] = useState(false);
  const [noScheduleAssigned, setHasNoScheduleAssigned] = useState(false);
  const [isMalformedSchedule, setIsMalformedSchedule] = useState(false);

  const [isSystemTimeInSync, setIsSystemTimeInSync] = useState(true);
  const [showTimeSyncWarningBanner, setShowTimeSyncBanner] = useState(false);
  const [timeSyncOffset, setTimeSyncOffset] = useState(0); // minutes

  const [minutesToUpdateDisplay, setMinutesToUpdateDisplay] = useState(60);

  // const [socket, setSocket] = useState(io.connect('http://localhost:8080/'));
  const [allDayRoom, setAllDayRoom] = useState(null);
  const [activeVideoSession, setActiveVideoSession] = useState(null);
  const headerRef = useRef(null);
  const tableHeadRef = useRef(null);
  const tableRowRef = useRef(null);
  const minutesToUpdateRef = useRef(null);
  const activeVideoSessionRef = useRef(null);
  const pendingPopupWindowRef = useRef(null);

  const { getTokenSilently, loginWithRedirect } = useAuth0();

  const dContext = useContext(DepartmentContext);
  const history = useHistory();
  const query = new URLSearchParams(useLocation().search);
  const isPreview = query.get('preview');

  const secondsToWait = 60;
  // const secondsToWait = 10;
  let hasFiredOnLoadSwal = false;

  useEffect(() => {
    activeVideoSessionRef.current = activeVideoSession;
  }, [activeVideoSession]);

  useEffect(() => {
    if (isDemo()) {
      if (!('Notification' in window)) {
      } else {
        if (isNotificationsSupported()) {
          Notification.requestPermission();
        }
      }
    }

    getDepartmentInfo();
    getAlertedEvents();

    let audio = new Audio(BellSound);
    audio.volume = 0.0;
    audio
      .play()
      // .then(() => {
      //   console.log('wakeup 0 volume played fine');
      // })
      .catch((err) => {
        console.log('wakeup 0 volume err: ', err);
      });

    setInterval(() => {
      if (minutesToUpdateRef.current > 0) {
        setMinutesToUpdateDisplay(minutesToUpdateRef.current - 1);
        minutesToUpdateRef.current = minutesToUpdateRef.current - 1;
      }
    }, 1000);
  }, []);

  useEffect(() => {
    if (indexesWithDifferences && indexesWithDifferences.length > 0) {
      clearTimeout(highlightClearTimeout);
    }
  }, [indexesWithDifferences]);

  useEffect(() => {
    if (!demo) {
      getData();
      // const recheckWait = 5 * 60 * 1000;

      setInterval(() => {
        getData();
      }, secondsToWait * 1000);
    } else {
      const nextFriday = getNextFriday();
      props.setUser(demoUserObject);
      setLoading(false);
      setIsLocalTime(true);
      setInterviewDate(nextFriday);
      setInterviewIsToday(nextFriday);
      setScheduledTimes(mockScheduledTimes);
      Swal.fire('This is a demo!', 'These are not real appointments.');
    }
  }, [clientID]);

  useEffect(() => {
    if (headerRef.current) {
      const { clientHeight } = headerRef.current;
      setTopOpacity(clientHeight);
    }
  }, [headerRef]);

  useEffect(() => {
    if (tableHeadRef.current) {
      const { clientHeight } = tableHeadRef.current;
      setHeaderOpacity(clientHeight);
    }
  }, [tableHeadRef]);

  useEffect(() => {
    if (tableRowRef.current) {
      const { clientHeight } = tableRowRef.current;
      setTableRowOpacity(clientHeight);
    }
  }, [tableRowRef]);

  useEffect(() => {
    if (alertedEvents && alertedEvents.length > 0) {
      localStorage.setItem('candidate_alertedEvents', JSON.stringify(alertedEvents));
    }
  }, [alertedEvents]);

  const tick = () => {
    const rightNow = new Date();
    const now = dayjs();
    if (scheduledTimes && scheduledTimes.length > 0 && document.getElementById('tableRow0')) {
      let heights = [];
      const lastJoinedMeeting = localStorage.getItem('candidate_lastJoinedMeeting');

      scheduledTimes.forEach((element, i) => {
        const itemIsBeforeCurrentMeeting = lastJoinedMeeting
          ? checkIfMeetingIsBeforeCurrentJoinedMeeting({
              lastJoinedMeeting: lastJoinedMeeting ? JSON.parse(lastJoinedMeeting) : null,
              itemToCheck: element,
            })
          : false;

        const height = document.getElementById('tableRow' + i).clientHeight;
        heights.push(height);

        if (itemIsBeforeCurrentMeeting) {
          return;
        }

        // if (i > 0 && !scheduledTimes[i - 1].isFiller) {
        checkForAlarm(element);
        // }
      });

      setHeights(heights);
    }

    // Check if "Early" message disappears 4:59 minutes before event.
    const earlyMessageCutOffTime = firstEvent
      ? dayjs(firstEvent.StartTimeAsMoment).subtract(firstBlockEarlyJoinInMinutes || 0, 'minutes')
      : null;

    if (firstEvent && now.isBefore(earlyMessageCutOffTime)) {
      setDisplayJoinMeetingButtonInfo(true);
    } else {
      setDisplayJoinMeetingButtonInfo(false);
    }

    if (demoTimeDifference && demo) {
      rightNow.setSeconds(rightNow.getSeconds() + demoTimeDifference);
      setCurrentTime(rightNow);
      setCurrentTimeAsMoment(dayjs(rightNow));
    } else {
      const rightNow = new Date();
      setCurrentTimeAsMoment(dayjs(rightNow));
      setCurrentTime(rightNow);
    }
  };

  const checkForAlarm = (item) => {
    const {
      Users = [],
      UUID,
      EndTimeAsMoment,
      StartTimeAsMoment,
      EndTime,
      StartTime,
      pk_InterviewDate,
      pk_ScheduleAssignment,
      pk_Timeslot,
      pk_ScheduleBlock,
      isFiller,
      isCustomMeeting,
      isPassingPeriod,
      isScheduleBlock,
      isFlexEvent,
    } = item;
    const joinKey = `${pk_Timeslot}_${pk_ScheduleAssignment}_${pk_ScheduleBlock}_${StartTime}_${EndTime}`;
    const itemIsBreak = !isCustomMeeting && !isFlexEvent && !isScheduleBlock && !isPassingPeriod;

    const joinedMeetings = localStorage.getItem('joinedMeetings') || [];
    const trackerKey = `${pk_Timeslot}_${pk_ScheduleAssignment}_${pk_ScheduleBlock}`;

    if (
      (Users.length > 0 || isFlexEvent || isCustomMeeting || isScheduleBlock) &&
      !joinedMeetings.includes(joinKey) &&
      !isFiller
    ) {
      const eventEndTime = EndTimeAsMoment;
      const eventEndTimeWithPassing = scheduleWithPassingPeriods[trackerKey];

      const formattedEndTime = EndTimeAsMoment.format('MMM DD, YYYY hh:mm A');
      const formattedStartTime = StartTimeAsMoment.format('MMM DD, YYYY hh:mm A');

      const now = dayjs();
      const realAlertedEvents = localStorage.getItem('candidate_alertedEvents')
        ? JSON.parse(localStorage.getItem('candidate_alertedEvents'))
        : [];
      const newAlertedEvents = realAlertedEvents.slice();
      alerts.forEach((a) => {
        const { Message, pk_Alert, Type } = a;
        const alertMinutes = a.Minutes;
        const key = `candidate_${pk_Candidate}_(${formattedStartTime})_(${formattedEndTime})_${pk_Alert}_${pk_Timeslot}_${pk_InterviewDate}`;
        let diffActual = -2;

        if (Type === 'End of Meeting') {
          diffActual = eventEndTime.diff(now, 'minutes', true);
        }

        if (Type === 'End of Passing') {
          diffActual = eventEndTimeWithPassing.diff(now, 'minutes', true);
        }

        // if (Type === 'End of Meeting') {
        //   diffActual = eventEndTime.diff(now, 'minutes', true);
        // } else if (Type === 'End of Passing') {
        //   diffActual = eventEndTimeWithPassing.diff(now, 'minutes', true);
        // } else {
        //   // console.log('Unknown Alert TYPE: ', Type);
        // }

        const alertIsNow = diffActual >= -1 && diffActual <= alertMinutes;
        const alertIsInThePast = diffActual < -1;

        if (alertIsNow && !realAlertedEvents.includes(key)) {
          if (isNotificationsSupported()) {
            try {
              new Notification(`${Message}`);
            } catch (e) {
              console.log('Failed to fire notif. Err: ', e);
            }
          }

          if (a.Sound === 'Bell') {
            let audio = new Audio(BellSound);
            audio.volume = 0.9;
            audio
              .play()
              // .then(() => {
              //   console.log('alert played fine');
              // })
              .catch((err) => {
                console.log('alert failed to play err: ', err);
              });
          }
          toast.info(Message);
        }

        if (alertIsNow || alertIsInThePast) {
          if (!newAlertedEvents.includes(key)) {
            newAlertedEvents.push(key);
            localStorage.setItem('candidate_alertedEvents', JSON.stringify(newAlertedEvents));
            setAlertedEvents(newAlertedEvents);
          }
        }
      });
    } else {
      if (!joinedMeetings.includes(joinKey) && pk_Timeslot == 1040) {
        //
      }
    }
  };

  const processSchedulesWithPassingPeriod = (schedule) => {
    const scheduleObject = scheduleWithPassingPeriods;

    schedule.forEach((item, i) => {
      const { pk_ScheduleAssignment, pk_Timeslot, pk_ScheduleBlock, isPassingPeriod, isFiller } = item;
      const key = `${pk_Timeslot}_${pk_ScheduleAssignment}_${pk_ScheduleBlock}`;
      if (isPassingPeriod || isFiller) {
        return;
      }
      let passingPeriodEnd;
      if (schedule[i + 1] && schedule[i + 1].isPassingPeriod) {
        passingPeriodEnd = schedule[i + 1].EndTimeAsMoment;
      } else {
        passingPeriodEnd = schedule[i].EndTimeAsMoment;
      }
      scheduleObject[key] = passingPeriodEnd;
    });
    setScheduleWithPassingPeriods(scheduleObject);
  };

  const getAlertedEvents = () => {
    const newAlertedEvents = localStorage.getItem('candidate_alertedEvents') || [];
    if (newAlertedEvents && newAlertedEvents.length > 0) {
      setAlertedEvents(JSON.parse(newAlertedEvents));
    }
  };

  const closeWindowIfOpen = (targetWindow) => {
    if (!targetWindow) {
      return;
    }

    try {
      if (!targetWindow.closed) {
        targetWindow.close();
      }
    } catch (error) {
      // ignore close errors
    }
  };

  const takePendingPopupWindow = () => {
    const pendingWindow = pendingPopupWindowRef.current;
    pendingPopupWindowRef.current = null;
    return pendingWindow;
  };

  const closePendingPopupWindow = () => {
    closeWindowIfOpen(takePendingPopupWindow());
  };

  const getBreakRoomUrl = () => {
    if (!breakRoom) {
      return '';
    }

    return breakRoom.url || '';
  };

  const getBreakRoomButtonText = () => {
    if (!breakRoom) {
      return 'Visit Break Room';
    }

    return breakRoom.buttonText || 'Visit Break Room';
  };

  const reusePopupForSession = (session, preOpenedWindow = null) => {
    if (!session || !session.id) {
      return false;
    }

    return openUrlInNewTabOrDetectBlock(
      buildRezrateVideoShellUrl(session.id),
      REZRATE_VIDEO_WINDOW_TARGET,
      preOpenedWindow,
    );
  };

  const discardActiveVideoSession = () => {
    const currentSession = activeVideoSessionRef.current;
    if (currentSession && currentSession.id) {
      removeRezrateVideoSession(currentSession.id);
    }
    setActiveVideoSession(null);
  };

  const getMeetingShellTitle = (item) => {
    if (!item) {
      return 'RezRATE Meeting';
    }

    if (item.EventName) {
      return item.EventName;
    }

    if (item.CustomMeetingTitle) {
      return item.CustomMeetingTitle;
    }

    if (item.Users && item.Users.length > 0) {
      return 'Interview Meeting';
    }

    return 'RezRATE Meeting';
  };

  const activateEmbeddedMeeting = ({ config, item, refreshUrl = '' }) => {
    const preOpenedWindow = takePendingPopupWindow();
    const iframeSrc = buildEmbeddedMeetingVideoUrl(config, {
      refreshUrl,
      returnUrl: window.location.href,
    });

    if (!iframeSrc) {
      closeWindowIfOpen(preOpenedWindow);
      Swal.fire('Error!', 'Unable to start embedded meeting (missing session token).', 'error');
      return false;
    }

    const currentSession = activeVideoSessionRef.current;
    const { session: nextSession, reusedExisting } = createOrReuseRezrateVideoSession({
      iframeSrc,
      title: getMeetingShellTitle(item),
    });

    if (!nextSession) {
      closeWindowIfOpen(preOpenedWindow);
      Swal.fire('Error!', 'Unable to prepare the meeting shell.', 'error');
      return false;
    }

    const reusedPopup = reusePopupForSession(nextSession, preOpenedWindow);
    if (!reusedPopup) {
      if (!(reusedExisting && currentSession && currentSession.id === nextSession.id)) {
        removeRezrateVideoSession(nextSession.id);
      }
      closeWindowIfOpen(preOpenedWindow);
      Swal.fire('Error!', 'Please allow RezRATE to open the meeting window.', 'error');
      return false;
    }

    if (currentSession && currentSession.id && currentSession.id !== nextSession.id) {
      removeRezrateVideoSession(currentSession.id);
    }

    setShowMeetingCard(false);
    setActiveVideoSession(nextSession);
    localStorage.setItem('candidate_lastJoinedMeeting', JSON.stringify(item));
    return true;
  };

  const prepareCandidatePopupForJoin = () => {
    const popupWindow = preOpenNamedMeetingWindow(REZRATE_VIDEO_WINDOW_TARGET);
    pendingPopupWindowRef.current = popupWindow;
    return popupWindow;
  };

  // Assume the url returned here is processed whether zoom or per-column.
  const getInterviewRoom = (item, options = {}) => {
    const { isAllDayJoin = false, allowAllDayFallback = true } = options;
    const { pk_InterviewDate, pk_ScheduleAssignment, pk_ScheduleBlock, pk_Timeslot, pk_FlexEvent, Users = [] } = item;
    const assignedUser = Users && Users.length > 0 ? Users[0].pk_User : null;
    fetchDataAgnostic('department/season/block/candidate/meeting', {
      pk_Department: dContext.department.pk_Department,
      pk_Season: dContext.season.pk_Season,
      UUID: clientID, // this is pk_Candidate
      pk_User: assignedUser,
      pk_ScheduleBlock,
      pk_FlexEvent,
      pk_InterviewDate,
      pk_Timeslot,
      pk_ScheduleAssignment,
      isAllDay: isAllDayJoin ? 1 : 0,
    })
      .then((result) => {
        const embeddedConfig = result?.data?.config?.config || result?.data?.config || null;
        if (embeddedConfig && (embeddedConfig.videoSDKJWT || embeddedConfig.signature)) {
          const refreshUrl = `${constructApiUrl('department/season/block/candidate/meeting')}?${new URLSearchParams({
            pk_Department: dContext.department.pk_Department,
            pk_Season: dContext.season.pk_Season,
            UUID: clientID,
            pk_ScheduleBlock,
            pk_FlexEvent,
            pk_InterviewDate,
            pk_Timeslot,
            pk_ScheduleAssignment,
          }).toString()}`;

          activateEmbeddedMeeting({
            config: embeddedConfig,
            item,
            refreshUrl,
          });
          return;
        }
        if (result.data && result.data.JoinURL) {
          const { DialInNumbers = [], JoinURL = '', MeetingId, Password } = result.data;

          if (result.data.JoinURL) {
            const urlFormatted = urlWithHttpProtocol(result.data.JoinURL);
            const preOpenedWindow = takePendingPopupWindow();
            handleMeetingCardShow({
              urlToUse: urlFormatted,
              meetingId: MeetingId,
              password: Password,
              zoomInfo: DialInNumbers,
              item,
              preOpenedWindow,
            });
            // setMeetingId(MeetingId);
            // setZoomPassword(Password);
            // setMeetingLink(urlFormatted);
            // setZoomInfo(DialInNumbers);

            // setShowMeetingCard(true);
            // setTimeout(() => {
            //   openURLInNewTab(urlFormatted);
            // }, 1000);
            // setTimeout(() => {
            //   setShowMeetingCard(false);
            // }, 3 * 60 * 1000);
            // localStorage.setItem('candidate_lastJoinedMeeting', JSON.stringify(item));
          } else {
            closePendingPopupWindow();
            Swal.fire('Error!', 'No meeting to join. Please contact the coordinator.', 'error');
          }
          return;
        }
        closePendingPopupWindow();
        Swal.fire('Error!', 'No meeting to join. Please contact the coordinator.', 'error');
      })
      .catch((err) => {
        const statusCode = err && err.response ? err.response.status : null;
        if (statusCode === 403 && allowAllDayFallback && !isAllDayJoin) {
          getInterviewRoom(item, {
            isAllDayJoin: true,
            allowAllDayFallback: false,
          });
          return;
        }
        closePendingPopupWindow();
        // These endpoints return some errors as a plain string body and others as { message }.
        // Surface whichever is present so the real reason (e.g. "Virtual Meeting Mode is Disabled")
        // is shown instead of the opaque "Request failed with status code 400".
        const responseData = err && err.response ? err.response.data : null;
        const serverMessage =
          responseData && typeof responseData === 'object'
            ? responseData.message
            : typeof responseData === 'string' && responseData.trim()
              ? responseData.trim()
              : null;
        const errorText = serverMessage || err.message || 'Unable to start meeting';
        Swal.fire('Error!', errorText, 'error');
      });
  };
  const openURLInNewTab = (urlFormatted, preOpenedWindow = null) => {
    const formatted = `${urlWithHttpProtocol(urlFormatted) || ''}`;
    if (!formatted) {
      closeWindowIfOpen(preOpenedWindow);
      return false;
    }
    const opened = openUrlInNewTabOrDetectBlock(
      formatted,
      REZRATE_VIDEO_WINDOW_TARGET,
      preOpenedWindow || takePendingPopupWindow(),
    );
    if (!opened) {
      closeWindowIfOpen(preOpenedWindow);
      Swal.fire('Error!', 'Please allow RezRATE to open the meeting window.', 'error');
      return false;
    }
    return true;
  };
  const handleBreakRoomClick = (breakItem) => {
    const breakRoomUrl = getBreakRoomUrl();

    if (breakRoomUrl) {
      if (shouldResolveRezrateEmbeddedMeeting(breakRoomUrl)) {
        prepareCandidatePopupForJoin();
        getInterviewRoom(breakItem, {
          isAllDayJoin: true,
          allowAllDayFallback: false,
        });
        return;
      }

      const pendingVideoWindow = prepareCandidatePopupForJoin();
      handleMeetingCardShow({
        urlToUse: breakRoomUrl,
        password: '',
        nonZoomInfo: breakRoom.details || '',
        meetingId: '',
        zoomInfo: [],
        item: breakItem,
        preOpenedWindow: pendingVideoWindow,
      });
    } else {
      Swal.fire('Error!', 'No link to join. Please contact the coordinator.', 'error');
    }
  };

  const showJoinMeetingButton = (message, url, priorityUrl, Schedules4Portal__pkUUID_Schedule, item, i) => {
    const now = dayjs();
    const earlyMessageCutOffTime = firstEvent ? dayjs(firstEvent.StartTimeAsMoment).subtract(5, 'minutes') : null;

    const isTooEarly = now.isBefore(earlyMessageCutOffTime);

    if (message === 'BREAK')
      return (
        <Fragment>
          <br />
          {getBreakRoomUrl() ? (
            <Button
              color="warning"
              disabled={checkForScheduleDisabledButton(item, now)}
              size="sm"
              onClick={(e) => {
                e.preventDefault();

                if (!demo) {
                  handleBreakRoomClick(item);
                } else {
                  Swal.fire('This is a demo!', 'This would normally join your meeting.');
                }
              }}
            >
              {getBreakRoomButtonText()}
            </Button>
          ) : null}
        </Fragment>
      );
    if (virtualMeetingMode !== 'Disabled') {
      return (
        <Fragment>
          <br />
          <Button
            color={'success'}
            size="sm"
            disabled={preventJoinMeetingClick || checkForScheduleDisabledButton(item, now)}
            style={{ minWidth: '95px' }}
            onClick={(e) => {
              if (checkForScheduleDisabledButton(item, dayjs())) {
                Swal.fire('Meeting Ended', 'This meeting is no longer available to join.', 'info');
                return;
              }
              let audio = new Audio(BellSound);
              audio.volume = 0.0;
              audio.play();

              e.preventDefault();
              // if (isTooEarly) {
              //   Swal.fire('Notice', `It's not time to join this meeting yet.`, 'info');
              //   return;
              // }

              const meetingBeforeThis = i > 1 ? scheduledTimes[i - 2] : null;
              if (meetingBeforeThis) {
                const {
                  Users = [],
                  UUID,
                  EndTimeAsMoment,
                  EndTime,
                  StartTime,
                  pk_Timeslot,
                  pk_ScheduleAssignment,
                  pk_ScheduleBlock,
                } = meetingBeforeThis;

                const joinKey = `${pk_Timeslot}_${pk_ScheduleAssignment}_${pk_ScheduleBlock}_${StartTime}_${EndTime}`;
                const joinedMeetings =
                  localStorage.getItem('joinedMeetings') && localStorage.getItem('joinedMeetings').length > 0
                    ? JSON.parse(localStorage.getItem('joinedMeetings'))
                    : [];
                if (!joinedMeetings.includes(joinKey)) {
                  joinedMeetings.push(joinKey);
                  localStorage.setItem('joinedMeetings', JSON.stringify(joinedMeetings));
                }
              }

              if (!demo) {
                const { virtualMeetingMode, interviewDateMeta = {}, enableEmbeddedMeetings = false } = rawData;
                const { MainRoomURL, MainRoomURLDetails } = interviewDateMeta;

                const { EventName, CustomMeetingTitle, Users } = item;
                if (Users && Users.length > 0) {
                  if (virtualMeetingMode === 'External') {
                    if (MainRoomURL) {
                      const pendingVideoWindow = prepareCandidatePopupForJoin();
                      handleMeetingCardShow({
                        urlToUse: MainRoomURL,
                        password: '',
                        nonZoomInfo: MainRoomURLDetails,
                        item,
                        preOpenedWindow: pendingVideoWindow,
                      });

                      // setMeetingId('');
                      // setZoomPassword('');
                      // setMeetingLink(MainRoomURL);
                      // setZoomInfo([]);
                      // setShowMeetingCard(true);
                      // setNonZoomInfo(MainRoomURLDetails || '');

                      // localStorage.setItem('candidate_lastJoinedMeeting', JSON.stringify(item));

                      // setTimeout(() => {
                      //   openURLInNewTab(MainRoomURL);
                      // }, 1000);
                      // setTimeout(() => {
                      //   setShowMeetingCard(false);
                      // }, 3 * 60 * 1000);
                    } else {
                      Swal.fire('Error!', 'No link to join. Please contact the coordinator.', 'error');
                    }
                  } else {
                    prepareCandidatePopupForJoin();
                    getInterviewRoom(item);
                  }
                } else if (EventName) {
                  const { UrlType, CustomUrl, CustomUrlDescription } = item;
                  let urlToOpen = MainRoomURL;

                  if (UrlType === 'Custom') {
                    urlToOpen = CustomUrl;
                  }

                  // When the department has embedded meetings enabled, the all-day / main-room
                  // welcome meeting is joined through the API-minted embedded session, not a stored
                  // URL. If the Main Room URL was never set to the embedded sentinel, still route
                  // through getInterviewRoom instead of failing closed. Gated on enableEmbeddedMeetings
                  // so non-embedded Internal departments (e.g. demo) keep the standard workflow.
                  const shouldEmbeddedFallback =
                    virtualMeetingMode === 'Internal' && enableEmbeddedMeetings && UrlType !== 'Custom';

                  if (!urlToOpen && shouldEmbeddedFallback) {
                    prepareCandidatePopupForJoin();
                    getInterviewRoom(item, {
                      isAllDayJoin: UrlType === 'AllDay',
                    });
                  } else if (!urlToOpen) {
                    Swal.fire(
                      'Error!',
                      'No link to join. No event has been created. Please contact your coordinator.',
                      'error',
                    );
                  } else {
                    if (virtualMeetingMode != 'Disabled') {
                      if (shouldResolveRezrateEmbeddedMeeting(urlToOpen)) {
                        prepareCandidatePopupForJoin();
                        getInterviewRoom(item, {
                          isAllDayJoin: UrlType === 'AllDay',
                        });
                      } else {
                        const pendingVideoWindow = prepareCandidatePopupForJoin();
                        if (openURLInNewTab(urlWithHttpProtocol(urlToOpen), pendingVideoWindow)) {
                          discardActiveVideoSession();
                        }
                      }
                    }
                  }
                } else if (CustomMeetingTitle) {
                  const { CustomMeetingUrl, VirtualRoomType, CustomMeetingDetails } = item;
                  let urlToOpen = VirtualRoomType === 'Custom' ? CustomMeetingUrl : MainRoomURL;

                  // When embedded meetings are enabled, a main-room/all-day custom meeting is joined
                  // through the API-minted embedded session, so fall back to getInterviewRoom when the
                  // Main Room URL hasn't been set to the embedded sentinel rather than failing closed.
                  // Gated on enableEmbeddedMeetings so non-embedded departments keep the standard flow.
                  const shouldEmbeddedFallback =
                    virtualMeetingMode === 'Internal' && enableEmbeddedMeetings && VirtualRoomType !== 'Custom';

                  if (!urlToOpen && shouldEmbeddedFallback) {
                    prepareCandidatePopupForJoin();
                    getInterviewRoom(item, {
                      isAllDayJoin: VirtualRoomType !== 'Custom',
                    });
                  } else if (!urlToOpen) {
                    Swal.fire(
                      'Error!',
                      'No link to join. No event has been created. Please contact your coordinator.',
                      'error',
                    );
                  } else {
                    if (virtualMeetingMode != 'Disabled') {
                      if (shouldResolveRezrateEmbeddedMeeting(urlToOpen)) {
                        prepareCandidatePopupForJoin();
                        getInterviewRoom(item, {
                          isAllDayJoin: VirtualRoomType !== 'Custom',
                        });
                      } else {
                        const pendingVideoWindow = prepareCandidatePopupForJoin();
                        if (openURLInNewTab(urlWithHttpProtocol(urlToOpen), pendingVideoWindow)) {
                          discardActiveVideoSession();
                        }
                      }
                    }
                  }
                } else {
                  Swal.fire(
                    'Error!',
                    'No Evaluators found. No Event found. Please contact your coordinator. ',
                    'error',
                  );
                }
              } else {
                Swal.fire('This is a demo!', 'This would normally join your meeting.');
              }
            }}
          >
            {preventJoinMeetingClick ? (
              <FontAwesomeIcon icon={faSpinner} spin />
            ) : (
              `${item.EventName ? 'Join Event' : 'Join Meeting'}`
            )}
          </Button>
        </Fragment>
      );
    }
  };

  const handleMeetingCardShow = (options) => {
    const {
      urlToUse,
      password = '',
      nonZoomInfo = '',
      meetingId = '',
      zoomInfo = [],
      item,
      preOpenedWindow = null,
    } = options;
    setMeetingId(meetingId);
    setZoomPassword(password);
    setMeetingLink(urlToUse);
    setZoomInfo(zoomInfo);
    setShowMeetingCard(true);
    setNonZoomInfo(nonZoomInfo || '');

    localStorage.setItem('candidate_lastJoinedMeeting', JSON.stringify(item));

    setTimeout(() => {
      if (openURLInNewTab(urlToUse, preOpenedWindow)) {
        discardActiveVideoSession();
      }
    }, 1000);

    setTimeout(() => {
      setShowMeetingCard(false);
    }, 3 * 60 * 1000);
  };

  const determineMessage = (scheduleItem) => {
    const { CustomMeetingTitle, Users, isPassingPeriod, isFlexEvent, EventName } = scheduleItem;

    if (isFlexEvent) {
      return EventName;
    }
    if (isPassingPeriod) {
      return 'Passing Period';
    }
    if (Users && Users.length > 0) {
      let message = null;
      const userCount = Users.length;
      Users.forEach((userItem) => {
        const { UserLast, UserFirst } = userItem;
        if (!message) {
          message =
            userCount >= 3
              ? `${UserFirst[0]}. ${UserLast}`
              : userCount == 2
              ? `${UserFirst} ${UserLast}`
              : `${UserLast}, ${UserFirst} `;
        } else {
          message +=
            userCount >= 3
              ? `, ${UserFirst[0]}. ${UserLast}`
              : userCount == 2
              ? ` & ${UserFirst} ${UserLast}`
              : `, ${UserFirst} ${UserLast} `;
        }
      });
      return message;
    }

    if (CustomMeetingTitle && CustomMeetingTitle !== '') {
      return CustomMeetingTitle;
    }

    // if it fits none of the above criteria, it's a break
    return 'Break';
  };

  const getData = () => {
    setIsLoadingSchedule(true);
    fetchDataAgnostic('schedule/candidateId', {
      UUID: clientID,
      pk_Department: dContext.department.pk_Department,
      pk_Season: dContext.season.pk_Season,
    })
      .then((res) => {
        if (res.data === false) {
          setHasNoScheduleAssigned(true);
        } else {
          const {
            interviewDate,
            currentServerTime,
            schedule = [],
            interviewDateMeta = {},
            alerts,
            virtualMeetingMode,
            firstBlockEarlyJoinInMinutes,
          } = res.data;
          const { MainRoomURL, MainRoomURLDetails, FirstName = '', LastName = '' } = interviewDateMeta;
          setRawData(res.data);
          setFirstName(FirstName);
          setLastName(LastName);

          if (isPreview && !hasFiredOnLoadSwal) {
            hasFiredOnLoadSwal = true;
            Swal.fire({
              title: 'Warning!',
              text: `You are acting on behalf of ${LastName}${FirstName && LastName ? ', ' : ''}${FirstName}`,
              icon: 'warning',
              confirmButtonText: 'I Understand',
              confirmButtonColor: '#d33',
            });
          }
          setFirstBlockEarlyJoinInMinutes(firstBlockEarlyJoinInMinutes);
          setVirtualMeetingMode(virtualMeetingMode);
          setBreakRoom(
            MainRoomURL
              ? {
                  url: MainRoomURL,
                  buttonText: 'Visit Break Room',
                  details: MainRoomURLDetails || '',
                }
              : { url: '', buttonText: '', details: '' },
          );

          if (res.data && res.data.noScheduledDate) {
            const { CandidateUUID } = res.data;
            return history.push(`/candidate/${CandidateUUID}`);
          }

          setInterviewDate(interviewDate);

          let newFirstEvent = null;
          schedule.forEach((item, i) => {
            item.message = determineMessage(item);

            item.StartTimeAsMoment = dayjs(item.StartTime);
            item.EndTimeAsMoment = dayjs(item.EndTime);
            if (newFirstEvent == null && !item.isFiller) {
              newFirstEvent = item;
            }
          });

          if (newFirstEvent) {
            setFirstEvent(newFirstEvent);
          }

          const { DateOfInterview, fk_Candidate } = interviewDateMeta;

          set_pk_Candidate(fk_Candidate);
          props.setPartDocumentTitle(dayjs(new Date(DateOfInterview)).format('MMM. D, YYYY'));
          let newStartMonth = null;
          let newEndMonth = null;

          if (schedule.length > 0) {
            if (schedule[0].StartTimeAsMoment) {
              newStartMonth = dayjs(schedule[0].StartTimeAsMoment).format('MMM DD, YYYY');
              newEndMonth = schedule[schedule.length - 1].EndTimeAsMoment.format('MMM DD, YYYY');
              setStartMonth(newStartMonth);
              setEndMonth(newEndMonth);
            } else {
              setIsMalformedSchedule(true);
              return;
            }
          } else {
            if (interviewDate) {
              newStartMonth = dayjs(interviewDate).format('MMM DD, YYYY');
              newEndMonth = newStartMonth;
              setStartMonth(newStartMonth);
              setEndMonth(newStartMonth);
            } else {
              setIsMalformedSchedule(true);
              return;
            }
          }

          const isToday =
            newStartMonth === dayjs(currentServerTime).format('MMM DD, YYYY') ||
            newEndMonth === dayjs(currentServerTime).format('MMM DD, YYYY');
          setInterviewIsToday(isToday);

          processSchedulesWithPassingPeriod(schedule);
          setScheduledTimes((prevState) => {
            const newIndexesWithDifferences = getArrayIndexesWithDifferencesViaTimeSlot(
              schedule || [],
              prevState || [],
              ['Users'],
            );

            if (newIndexesWithDifferences && newIndexesWithDifferences.length > 0) {
              setIndexesWithDifferences(newIndexesWithDifferences);

              Swal.fire({
                title: 'Schedule has been updated',
                text: 'Changes are highlighted!',
              }).then(() => {
                highlightClearTimeout = setTimeout(() => {
                  setIndexesWithDifferences([]);
                }, [8000]);
              });
            }

            return schedule;
          });

          setAlerts(alerts);
        }
        setError(false);
        setLoading(false);
        setIsLoadingSchedule(false);
        setHasScheduleError(false);
        setMinutesToUpdateDisplay(secondsToWait);
        minutesToUpdateRef.current = secondsToWait;
      })
      .catch((err) => {
        setIsLoadingSchedule(false);
        setHasScheduleError(true);
        setMinutesToUpdateDisplay(secondsToWait);
        minutesToUpdateRef.current = secondsToWait;

        if (err && err.response && err.response.status === 404) {
          setValidCandidate(false);
        } else {
          toast.error('Error loading schedule');
          // Swal.fire('Error!', `${err.message}`, 'error');
          setError(true);
        }
      });
  };

  const getDepartmentInfo = () => {
    if (props && props.match && props.match.params && props.match.params.id) {
      fetchDataAgnostic('department/season/candidate/scheduleId', { scheduleUUID: props.match.params.id })
        .then((result) => {
          props.setUser(result.data);
          const {
            HasDeclinedInterview,
            CandidateUUID,
            HasBeenSentWaitlist,
            ScheduledInterviewId,
            currentServerTime,
          } = result.data;

          const serverTime = dayjs(currentServerTime);
          const systemTime = dayjs();
          const timeDifference = serverTime.diff(systemTime, 'minutes');

          if (Math.abs(timeDifference) >= 2) {
            setShowTimeSyncBanner(true);
          }

          setTimeSyncOffset(timeDifference);

          // if the candidate has declined the interview, redirect them to the interview date
          // selection page
          if (HasDeclinedInterview) {
            history.push(`/candidate/${CandidateUUID}`);
          }
          // if they have not been sent their waitlist data or they're not scheduled then they're pending
          if (HasBeenSentWaitlist === false && ScheduledInterviewId == null) {
            setStatusPending(true);
          } else {
            setStatusPending(false);
          }
        })
        .catch((err) => {});
    }
  };

  // Seems REDUNDANT with determineMessage - Tere
  const renderMessage = (item, isPassingPeriod) => {
    if (item.isFiller) {
      return 'Break';
    }
    if (isPassingPeriod) {
      return 'Passing Period';
    }
    if (item.CustomMeetingTitle) {
      return item.CustomMeetingTitle;
    }
    if (item.Users) {
      let message = '';

      item.Users.forEach((item) => {
        const { UserFirst, UserLast } = item;
        message += `${UserLast}, ${UserFirst}`;
      });
      return message;
    }
    return item.message;
  };

  const renderStatusMessage = () => {
    if (hasScheduleError) {
      return (
        <div
          style={{
            color: hasScheduleError ? 'red' : null,
            textAlign: 'center',
            fontSize: 12,
            fontWeight: 'bold',
            padding: 5,
          }}
        >
          {`Error Updating data! Retrying in ${`${minutesToUpdateDisplay}s`}. . .`}
        </div>
      );
    }
  };

  const populateDates = () => {
    let dateformatTime;
    let difference;
    let color = null;
    let coverBorder = null;
    const items = scheduledTimes.map((item, i) => {
      const { isPassingPeriod } = item;
      let last = false;
      const stringDate = interviewDate + ' ' + item.Schedules4PortalTime;
      const numberDate = Date.parse(stringDate);
      dateformatTime = new Date(numberDate);

      difference = getPercentageTime(
        currentTimeAsMoment.valueOf(),
        heights && heights[i] ? heights[i] : tableRowOpacity,
        item.StartTimeAsMoment.valueOf(),
        item.EndTimeAsMoment.valueOf(),
      );

      const joinMeetingButtonVisisble = shouldJoinMeetingButtonBeVisisble(item, demo, currentTimeAsMoment);

      const isCurrentTimeSlot = difference.height !== 0 && difference.height !== '100%';
      const shouldBeVisible = demo ? isCurrentTimeSlot : joinMeetingButtonVisisble;

      const showHighlight = indexesWithDifferences.includes(i);
      const rowBackgroundColor = showHighlight ? '#c4fcbb' : alternatingRowColors[i % alternatingRowColors.length];
      const messageFlashRed = false;
      const message = item.message; // renderMessage(item, isPassingPeriod);

      return (
        <tr
          ref={tableRowRef}
          key={dateformatTime + i}
          style={{ backgroundColor: rowBackgroundColor }}
          className={isPassingPeriod ? 'dashed_top_line' : ''}
        >
          <TDPadding className="d-none d-sm-table-cell" />
          {interviewIsToday &&
            isLocalTime &&
            createTimeTracker(heights, i, difference, color, coverBorder, null, isPassingPeriod)}
          <td id={'tableRow' + i} style={{ verticalAlign: 'middle' }}>
            <p className={'red_staging '} style={{ margin: 0 }}>
              <span style={{ whiteSpace: 'nowrap', fontWeight: isCurrentTimeSlot ? 700 : 400 }}>
                {dayjs(item.StartTimeAsMoment).format('h:mm A')}
              </span>
            </p>
          </td>
          <td style={{ verticalAlign: 'middle' }}>
            <p className={'red_staging '} style={{ margin: 0, textAlign: 'center' }}>
              {message}

              {item.RoomLabel ? <div>{item.RoomLabel}</div> : null}

              {/* {item.TimeSlots4PortalAltRoom !== '' ? item.TimeSlots4PortalAltRoom : item.Schedules4PortalRoomNumber} */}

              {shouldBeVisible &&
                // interviewIsToday &&
                !isPassingPeriod &&
                showJoinMeetingButton(
                  message.toUpperCase(),
                  item.TimeSlots4PortalJoinManualURL,
                  item.Schedules4PortalJoinManualURL,
                  item.Schedules4Portal__pkUUID_Schedule,
                  item,
                  i,
                )}
            </p>
          </td>

          <TDPadding className="d-none d-sm-table-cell" />
        </tr>
      );
    });
    return items;
  };

  if (!validCandidate) {
    return <div style={{ width: '100%' }}>{renderCandidateNotFound()}</div>;
  }

  if (error) {
    return <Error />;
  }

  if (loading) {
    return (
      <div
        style={{
          height: 'calc(100vh - 100px )',
          width: '100vw',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <div style={{ height: 100, width: 100, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <Loading />
        </div>
      </div>
    );
  }

  if (noData) {
    return <Error header={'Schedule is not currently published.'} subHeader="Please check back later." />;
  }

  return (
    <HeaderWrapper>
      <CandidateHeader showNotifTester={!noScheduleAssigned} />
      {noScheduleAssigned || isMalformedSchedule ? (
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            textAlign: 'center',
            padding: 5,
            width: '100%',
            justifyContent: 'center',
            marginTop: '20vh',
          }}
        >
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
              width: '100%',
            }}
          >
            <Alert color="danger">
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'row',
                  fontSize: 30,
                  justifyContent: 'center',
                  alignItems: 'center',
                }}
              >
                <div
                  style={{
                    display: 'flex',
                    flexDirection: 'column',
                    width: '27vw',
                    justifyContent: 'center',
                    alignItems: 'flex-end',
                    fontSize: 60,
                  }}
                >
                  {/* <FontAwesomeIcon icon={faTimesCircle} /> */}
                  <FontAwesomeIcon icon={faExclamationCircle} />
                </div>
                <div
                  style={{
                    display: 'flex',
                    flexDirection: 'column',
                    width: '100%',
                    alignContent: 'flex-start',
                    textAlign: 'left',
                    paddingLeft: 20,
                  }}
                >
                  <div>
                    {noScheduleAssigned
                      ? 'You are not currently scheduled for an interview.'
                      : isMalformedSchedule
                      ? 'Unable to retrieve valid schedule at this time'
                      : 'Error loading schedule.'}
                  </div>
                  <div>Please contact your coordinator for further assistance.</div>
                </div>
              </div>
            </Alert>
          </div>
        </div>
      ) : (
        <CustomCol key={2} sm={12}>
          <form id="zoom_form" target="rezrate-video"></form>
          {renderMeetingDetailsCard({
            showMeetingCard,
            setShowMeetingCard,
            meetingLink,
            setCopied,
            copied,
            zoomInfo,
            zoomPassword,
            mainRoomDescription,
            meetingId,
            nonZoomInfo,
          })}
          <CandidateWorkspace>
            <CandidateSchedulePane>
              <CustomCard>
                <CustomCardHeader ref={headerRef}>
                  <h4>
                    Your Schedule
                    <br />{' '}
                    {startMonth === endMonth
                      ? `${dayjs(startMonth).format('dddd, MMMM DD, YYYY')}`
                      : `${startMonth} - ${endMonth}`}
                  </h4>
                  {demo && (
                    <div style={{ display: 'flex', alignItems: 'center', flexDirection: 'column' }}>
                      <p>
                        <FontAwesomeIcon icon={faInfoCircle} /> Because you're using the demo, you can change the time
                        of day.
                      </p>
                      <Input
                        style={{ maxWidth: '200px' }}
                        type="select"
                        name="select"
                        id="exampleSelect"
                        onChange={(e) => {
                          if (e.target.value === 'Current Time') {
                            setDemoTimeDifference(null);
                          } else {
                            const rightNow = new Date(Date.now());
                            const newTime = new Date(e.target.value);
                            var difference = newTime.getTime() - rightNow.getTime(); // This will give difference in milliseconds
                            var resultsInSeconds = Math.round(difference / 1000) + 2;
                            setDemoTimeDifference(resultsInSeconds);

                            tick();
                            // setCurrentTime(e.target.value);
                          }
                        }}
                      >
                        <option>Current Time</option>
                        {mockScheduledTimes.map((item) => {
                          return <option value={item.time}>{dayjs(item.time).format('h:mm a')}</option>;
                        })}
                      </Input>
                    </div>
                  )}

                  <div style={{ color: 'white', fontSize: 14 }}>
                    Times are displayed in your device&apos;s local time zone.
                  </div>
                </CustomCardHeader>
                {isPreview && (
                  <div style={{ backgroundColor: '#FFD2D2', textAlign: 'center', paddingTop: 5, paddingBottom: 5 }}>
                    <h5>
                      You are acting on behalf of <b>{`${lastName}${firstName && lastName ? ', ' : ''}${firstName}`}</b>
                      .
                    </h5>
                  </div>
                )}
                {displayJoinMeetingButtonInfo && virtualMeetingMode !== 'Disabled' && (
                  <div style={{ backgroundColor: '#ffe900', textAlign: 'center' }}>
                    <h5>
                      You&apos;re early! Join meeting button will become active {firstBlockEarlyJoinInMinutes || 0}{' '}
                      minute
                      {firstBlockEarlyJoinInMinutes > 1 ? 's' : ''} before your first meeting.
                    </h5>
                  </div>
                )}
                {showTimeSyncWarningBanner && (
                  <div
                    style={{
                      display: 'flex',
                      flexDirection: 'row',
                      textAlign: 'center',
                      backgroundColor: '#f0ad4e',
                      justifyContent: 'center',
                    }}
                  >
                    <span>
                      <b>
                        WARNING: Your system time appears to be improperly set. This may cause issues with the schedule,
                        notifications, and joining meetings.
                      </b>
                    </span>
                  </div>
                )}
                {renderStatusMessage()}
                <CustomTable>
                  <thead ref={tableHeadRef}>
                    <tr>
                      <th id="padding-header" className="d-none d-sm-table-cell"></th>
                      {interviewIsToday && isLocalTime && (
                        <th style={{ whiteSpace: 'nowrap', paddingRight: 0 }}>
                          {dayjs(currentTime).format('h:mm:ss A')}
                        </th>
                      )}
                      <th>Time</th>
                      <th style={{ textAlign: 'center' }}>Event</th>
                      {hasRoomNumber && <th style={{ textAlign: 'center' }}>Room</th>}
                      <th className="d-none d-sm-table-cell"></th>
                    </tr>
                  </thead>
                  <tbody>{populateDates()}</tbody>
                </CustomTable>
              </CustomCard>
            </CandidateSchedulePane>
          </CandidateWorkspace>
        </CustomCol>
      )}
    </HeaderWrapper>
  );
};

export default InterviewSchedule;
